import { useMemo } from 'react'
import selection from './selection.json'

const SvgIcon = ({
  name,
  size = 32,
  color,
  offset = 0,
  strokeWidth = 1,
  width,
  height,
  viewBoxWidthPercentage,
  viewBoxHeightPercentage,
  onClick,
  style,
  withBackground = false,
  backgroundColor = '#eee',
  id,
  className,
  disabled = false,
  testId,
}) => {
  const viewBoxMax = 1024
  const localOffset = (offset / 2) * -viewBoxMax
  const offsetedViewBox = viewBoxMax - localOffset

  const currentIcon = useMemo(() => {
    if (!name) return null
    return selection.icons
      .map((i) => ({
        name: i.properties.name,
        paths: i.icon.paths,
        attrs: i.attrs,
      }))
      .find((i) => i.name === name)
  }, [name])

  if (!currentIcon) {
    console.warn(`Icon "${name}" not found in selection.json`)
    return null
  }

  const paths = currentIcon.paths.map((p, i) => (
    <path
      key={i}
      d={p}
      strokeWidth={5 * strokeWidth}
      stroke={
        disabled ? '#ccc' : color || currentIcon.attrs?.[i]?.fill || 'black'
      }
      fill={
        disabled ? '#ccc' : color || currentIcon.attrs?.[i]?.fill || 'black'
      }
    />
  ))

  const svgWidth = width || height || size
  const svgHeight = height || width || size
  const viewBoxWidth = viewBoxWidthPercentage
    ? offsetedViewBox * viewBoxWidthPercentage
    : offsetedViewBox
  const viewBoxHeight = viewBoxHeightPercentage
    ? offsetedViewBox * viewBoxHeightPercentage
    : offsetedViewBox

  const iconScale = 0.6

  const backgroundCircle = withBackground ? (
    <circle
      cx={viewBoxMax / 2}
      cy={viewBoxMax / 2}
      r={viewBoxMax / 2}
      fill={backgroundColor}
    />
  ) : null

  const iconGroup = (
    <g
      transform={`
      scale(${iconScale})
      translate(${(1 - iconScale) * (viewBoxMax / (2 * iconScale))}, ${(1 - iconScale) * (viewBoxMax / (2 * iconScale))})
    `}
    >
      {paths}
    </g>
  )

  return (
    <svg
      id={id}
      data-testid={testId}
      width={svgWidth}
      height={svgHeight}
      viewBox={`${localOffset} ${localOffset} ${viewBoxWidth} ${viewBoxHeight}`}
      xmlns="http://www.w3.org/2000/svg"
      onClick={disabled ? undefined : onClick}
      style={{
        cursor: disabled ? 'not-allowed' : onClick ? 'pointer' : 'default',
        opacity: disabled ? 0.6 : 1,
        ...style,
      }}
      className={className}
    >
      {backgroundCircle}
      {iconGroup}
    </svg>
  )
}

export default SvgIcon
